import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function PublicSurveyList() {
  const navigate = useNavigate();
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadSurveys();
  }, []);

  const loadSurveys = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/surveys`);
      setSurveys(response.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to load form: ' + err.message);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="public-container">
        <div className="public-header">
          <img src="/Aqlyze-logo.png" alt="Aqlyze" className="public-logo" />
        </div>
        <div className="loading">Loading Forms...</div>
      </div>
    );
  }

  return (
    <div className="public-container">
      <div className="public-header">
        <img src="/Aqlyze-logo.png" alt="Aqlyze" className="public-logo" />
      </div>

      <div className="public-content">
        <h2 className="public-title">Available Forms</h2>
        <p className="public-subtitle">Select a form to begin</p>

        {error && <div className="error">{error}</div>}

        {surveys.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">📋</div>
            <h3>No Forms available</h3>
            <p>Please check back later</p>
          </div>
        ) : (
          <div className="public-survey-grid">
            {surveys.map((survey) => (
              <div key={survey._id} className="public-survey-card">
                <h3 className="public-card-title">{survey.title}</h3>
                {survey.description && (
                  <p className="public-card-text">{survey.description}</p>
                )}
                <button
                  onClick={() => navigate(`/public/survey/${survey._id}`)}
                  className="button button-success"
                  style={{ width: '100%', marginTop: '1rem' }}
                >
                  📝 Take Form
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PublicSurveyList;